import { InjectionToken } from '@angular/core';

export interface GooglePlacesApi {
  createAutocomplete(
    input: HTMLInputElement,
    options?: google.maps.places.AutocompleteOptions
  ): Promise<google.maps.places.Autocomplete>;
}

export const GOOGLE_PLACES_API = new InjectionToken<GooglePlacesApi>('GOOGLE_PLACES_API');
